export enum UserProfileQueryKeys {
  UseBrewingSpecialsSettingsGet = "useBrewingSpecialsSettingsGet",
  UseFeatureEnabledGet = "useFeatureEnabledGet",
  UseFeaturesGet = "useFeaturesGet",
  UseGeneralSettingsGet = "useGeneralSettingsGet",
  UseUsersGet = "useUsersGet",
}
